import React from 'react'
import Room from '../../../../features/room/Room'
import MainBottom from '../mainBottom/MainBottom'
import MainTop from '../mainTop/MainTop'
import useDisposableModals from '../../../../features/disposableModals'
import { useCheckOnCompleteSomeQuests } from '../../../../../hooks/useCheckOnCompleteSomeQuests'
import useMainInfoModals from '../../model/hooks/useMainInfoModals'
import useHandleTaskComplete from '../../model/hooks/useHandleTaskComplete'
import useClearServiceDataModals from '../../model/hooks/useClearServiceDataModals'
import useHandleLevelRewards from '../../model/hooks/useHandleLevelRewards'
import MainToShopButton from '../mainToShopButton/MainToShopButton'
import MainToggleBathButton from '../mainToggleBathButton/MainToggleBathButton'
import useHandleAchievements from '../../model/hooks/useHandleAchievements'
import useGiftClothesModal from '../../model/hooks/useGiftClothesModal'
import useGiftWishesModal from '../../model/hooks/useGiftWishesModal'
import useModalsWithRedirect from '../../model/hooks/useModalsWithRedirect'
import useSeasonModals from '../../model/hooks/useSeasonModals'
import useCheckUserBeautiesBalance from '../../model/hooks/useCheckUserBeautiesBalance'
import useReachLevelRewardDraw from '../../model/hooks/useReachLevelRewardDraw'

const Main = React.forwardRef(function (_, ref) {
  // хук для обновления баланса бьютисов пользователя если прошло более 30 секунд с последнего запроса
  useCheckUserBeautiesBalance()

  // подробнее про модальные окна в readme/MODALS.md
  useSeasonModals() // бокс и премиум
  useDisposableModals() // модальные окна с бэка
  useMainInfoModals({
    main: [
      useHandleLevelRewards(), // награда за пройденный уровень/уровни
      useReachLevelRewardDraw(), // награда за пройденный уровень для участия в конкурсе
      useGiftClothesModal(), // подарок от другого пользователя
      useGiftWishesModal(), // открытки
      useModalsWithRedirect({
        isShowOneModalOnSession: false,
        isShowOneModalOnMount: true,
      }), // различные промо, праздники и тп
    ],
    bath: [],
  })
  useHandleAchievements() // новая ачивка
  useClearServiceDataModals() // чистит сервисные данные от ненужных полей в modalsData
  useCheckOnCompleteSomeQuests()
  useHandleTaskComplete()

  return (
    <section
      className={'main'}
      ref={ref}
    >
      <Room />
      <MainTop />

      <div className={'main__bathroom-wrapper'}>
        <MainToggleBathButton />
        <MainToShopButton />
      </div>

      <MainBottom />
    </section>
  )
})

export default Main
